import React from "react";
import "./Button.css";

export default function Button({
  children,
  size = "md",
  appearence = "default",
  className = "",
  ...props
}) {
  return (
    <button className={`button ${size} ${appearence} ${className}`} {...props}>
      {children}
    </button>
  );
}
